import type { UIMessage } from 'ai'
import { api } from './api'

export type ConversationSummary = { id: string; title: string; lastMessageAt: string; createdAt: string }
export type ConversationDetail = ConversationSummary & { messages: UIMessage[] }

export const listConversations = (orgId: string) => api.getPage<ConversationSummary>(`/orgs/${orgId}/conversations?limit=50`)
export const getConversation = (orgId: string, id: string) => api.get<ConversationDetail>(`/orgs/${orgId}/conversations/${id}`)
export const deleteConversation = (orgId: string, id: string) => api.delete<null>(`/orgs/${orgId}/conversations/${id}`)
